import { Action } from 'redux';
import { UpdateUnreadUserNotifications } from '../../../app/actions/AppActionTypes';
import { IUserNotification } from '../../models/IUserNotification';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface UpdateUnreadUserNotificationsAction extends Action { }



export function updateUnreadUserNotificationsAction(): UpdateUnreadUserNotificationsAction {
  return {
    type: UpdateUnreadUserNotifications,
  };
}

export const isUpdateUnreadUserNotificationsAction = isActionFactory<UpdateUnreadUserNotificationsAction>(UpdateUnreadUserNotifications);
